import { ROUTE_PAYMENT, ROUTE_PAYMENT_COLLECT_PAYMENT_METHOD } from '@/constants/routes';
import setTitleFromLoader from '@/utils/routing/set-title';
import { Navigate, RouteObject } from 'react-router-dom';
import { routePaymentCollectPaymentMethod } from './components/method/payment-method.route';
import { routePaymentVerifyPayment } from './components/verify/payment-verify.route';
import { getRoute } from '@/utils';
import { PPRAPaymentPage } from '../ppra/components/ppra-payment-page/PPRAPaymentPage';

export const routePayment: RouteObject = {
  Component: PPRAPaymentPage,
  path: ROUTE_PAYMENT,
  children: [
    { index: true, element: <Navigate to={getRoute(ROUTE_PAYMENT_COLLECT_PAYMENT_METHOD)} replace /> },
    routePaymentCollectPaymentMethod,
    routePaymentVerifyPayment,
  ],
  loader: setTitleFromLoader('Payment'),
};
